import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import classes from './login.module.css';
import SocialLoginButton from '../../components/containers/socialLoginButton/socialLoginButton';
import InputField from '../../components/containers/inputField/inputField';
import { connect } from 'react-redux';
import * as actions from "../../store/actions/index";
import { NavLink } from 'react-router-dom';
import PromptMessage from '../../components/containers/promptMessage/promptMessage';
import { sixYardAxios } from "../../sixYardAxios";

const Login = (props) => {
  const navigate = useNavigate();
  const [showPrompt, setShowPrompt] = useState(true);
  const [needsVerification, setNeedsVerification] = useState(false);
  const [isResendingOTP, setIsResendingOTP] = useState(false);
  const translations = {
    notMember: {
      en: 'Not a member yet?',
      ar: 'لست عضواً بعد؟'
    },
    whyCreate: {
      en: 'Why to create an account?',
      ar: 'لماذا تنشئ حساباً؟'
    },
    rewardText: {
      en: 'To get rewarded with loyalty program and track all your activities with us',
      ar: 'للحصول على مكافآت من برنامج الولاء وتتبع جميع أنشطتك معنا'
    },
    login: {
      en: 'LOGIN',
      ar: 'تسجيل الدخول'
    },
    forgotPassword: {
      en: 'Forgot Password?',
      ar: 'نسيت كلمة المرور؟'
    },
    loginBy: {
      en: 'Or login by',
      ar: 'أو سجل الدخول عبر'
    },
    noAccount: {
      en: "Don't have an account?",
      ar: 'ليس لديك حساب؟'
    },
    signUp: {
      en: 'Sign Up',
      ar: 'تسجيل'
    },
    email: {
      en: 'Email',
      ar: 'البريد الإلكتروني'
    },
    password: {
      en: 'Password',
      ar: 'كلمة المرور'
    },
    enterEmail: {
      en: 'Enter email',
      ar: 'أدخل البريد الإلكتروني'
    },
    enterPassword: {
      en: 'Enter password',
      ar: 'أدخل كلمة المرور'
    },
    verifyEmail: {
      en: 'Please verify your email first',
      ar: 'يرجى التحقق من بريدك الإلكتروني أولاً'
    },
    resendOTP: {
      en: 'Resend OTP',
      ar: 'إعادة إرسال رمز التحقق'
    },
    verifyNow: {
      en: 'Verify Now',
      ar: 'تحقق الآن'
    },
    sendingOTP: {
      en: 'Sending OTP...',
      ar: 'جاري إرسال رمز التحقق...'
    }
  };
  const [controls, setControls] = useState({
    email: {
      elementType: "input",
      elementConfig: {
        type: "email",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterEmail.en : translations.enterEmail.ar,
      },
      value: "",
      label: parseInt(localStorage.getItem('language')) === 1 ? translations.email.en : translations.email.ar,
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false
    },
    password: {
      elementType: "input",
      elementConfig: {
        type: "password",
        placeholder: parseInt(localStorage.getItem('language')) === 1 ? translations.enterPassword.en : translations.enterPassword.ar,
      },
      value: "",
      validation: {
        required: true,
        minLength: 6,
        maxLength: 32,
      },
      label: parseInt(localStorage.getItem('language')) === 1 ? translations.password.en : translations.password.ar,
      valid: false,
      touched: false
    }
  });
  const formElementsArray = [];
  for (let key in controls) {
    formElementsArray.push({
      id: key,
      config: controls[key]
    });
  }
  const form = formElementsArray.map((formElement, i) => (
    <div key={i} className={classes.FormGroup}>
      <InputField
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        touched={formElement.config.touched}
        withRemove={false}
        label={formElement.config.label}
        changed={event => inputChangedHandler(event, formElement.id)}
      />
    </div>
  ));
  const checkValidity = ((value, rules) => {
    let isValid = true;
    if (!rules) {
      return true;
    }

    if (rules.required) {
      value = typeof value === 'string' ? value.trim() : value;
      isValid = value !== "" && isValid;
    }

    if (rules.minLength) {
      isValid = value?.length >= rules.minLength && isValid;
    }

    if (rules.maxLength) {
      isValid = value?.length <= rules.maxLength && isValid;
    }

    if (rules.isEmail) {
      const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
      isValid = pattern.test(value) && isValid;
    }

    if (rules.isNumeric) {
      const pattern = /^\d+$/;
      isValid = pattern.test(value) && isValid;
    }

    return isValid;
  })
  const inputChangedHandler = (event, controlName) => {
    const updatedControls = {
      ...controls,
      [controlName]: {
        ...controls[controlName],
        value: event.target.value,
        valid: checkValidity(
          event.target.value,
          controls[controlName].validation
        ),
        touched: true
      }
    };
    setControls(updatedControls);
  };
  const socialLoginOptions = [
    { 
      provider: 'google',
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/28bd1d58bec89ad2a3a756cb60ed110fcf90a8ba6843ff87bb59b20414b5b9d0",
      alt: "Google login" 
    },
    { 
      provider: 'facebook',
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/c983773de3122b7a0a4300e505e9c567cd185514936f7f7aa460cd6c8b21f8e5",
      alt: "Facebook login" 
    },
    { 
      provider: 'microsoft',
      icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/d6d242305b28473efd487f01949c7703a61fb3baaad156a1da7299b90641eeea",
      alt: "Microsoft login" 
    }
  ];
  useEffect(() => {
    props.isAuthenticated && navigate('/');
  }, [props.isAuthenticated]);

  useEffect(() => {
    props.onClearError();
    return () => { props.onClearError(); }
  }, [])

  const submitHandler = e => {
    setShowPrompt(true);
    e.preventDefault();
    if (needsVerification) {
      handleResendOTP();
    } else {
      controls.email.value && controls.password.value && props.onAuth(
        controls.email.value,
        controls.password.value
      );
    }
  };

  const handleResendOTP = () => {
    setIsResendingOTP(true);
    setShowPrompt(false);
    
    sixYardAxios.post(
      "/auth/resend-otp",
      JSON.stringify({
        email: controls.email.value
      }),
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }
      }
    )
    .then(res => {
      setIsResendingOTP(false);
      navigate('/register', { 
        state: { 
          email: controls.email.value, 
          fromLogin: true,
          showOTP: true
        }
      });
    })
    .catch(err => {
      setIsResendingOTP(false);
      setShowPrompt(true);
    });
  };

  useEffect(() => {
    if (props.error && props.error.message === "Please verify your email first") {
      setNeedsVerification(true);
    } else {
      setNeedsVerification(false);
    }
  }, [props.error]);

  return (
    <div className={classes.Container}>
      <h1>{parseInt(localStorage.getItem('language')) === 1 ? translations.notMember.en : translations.notMember.ar}</h1>
      <p className={classes.Description}>
        <span>{parseInt(localStorage.getItem('language')) === 1 ? translations.whyCreate.en : translations.whyCreate.ar}</span>
        {parseInt(localStorage.getItem('language')) === 1 ? translations.rewardText.en : translations.rewardText.ar}
      </p>
      <h2>{parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}</h2>
      <div className={classes.FormLayout}>
        <form className={classes.Form} onSubmit={(e) => submitHandler(e)}>
          {form}
          <NavLink to='/forgot-password' className={classes.ForgotPassword}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.forgotPassword.en : translations.forgotPassword.ar}
          </NavLink>
          <button type="submit" className={classes.Button}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.login.en : translations.login.ar}
          </button>
        </form>
        <div className={classes.Divider}>
          <span className={classes.DividerLine} />
          <span className={classes.DividerText}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.loginBy.en : translations.loginBy.ar}
          </span>
          <span className={classes.DividerLine} />
        </div>
        <div className={classes.SocialLoginContainer}>
          {socialLoginOptions.map((option, index) => (
            <SocialLoginButton 
              key={index} 
              provider={option.provider}
              icon={option.icon} 
              alt={option.alt} 
            />
          ))}
        </div>
        <p className={classes.Prompt}>
          {parseInt(localStorage.getItem('language')) === 1 ? translations.noAccount.en : translations.noAccount.ar} 
          <a href="/register" className={classes.Link}>
            {parseInt(localStorage.getItem('language')) === 1 ? translations.signUp.en : translations.signUp.ar}
          </a>
        </p>
      </div>
      {props.error && showPrompt && !needsVerification && (
        <PromptMessage 
          message={props.error.message} 
          status='ERROR' 
          button='CLOSE' 
          click={() => setShowPrompt(false)} 
        />
      )}
      {needsVerification && showPrompt && (
        <PromptMessage 
          message={parseInt(localStorage.getItem('language')) === 1 ? translations.verifyEmail.en : translations.verifyEmail.ar} 
          status='WARNING' 
          button={isResendingOTP ? 
                 (parseInt(localStorage.getItem('language')) === 1 ? translations.sendingOTP.en : translations.sendingOTP.ar) : 
                 (parseInt(localStorage.getItem('language')) === 1 ? translations.resendOTP.en : translations.resendOTP.ar)} 
          click={handleResendOTP} 
          additionalButton={parseInt(localStorage.getItem('language')) === 1 ? translations.verifyNow.en : translations.verifyNow.ar}
          additionalButtonClick={() => {
            navigate('/register', { 
              state: { 
                email: controls.email.value, 
                fromLogin: true,
                showOTP: true
              }
            });
          }}
        />
      )}
    </div>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    onAuth: (email, password) => dispatch(actions.auth(email, password)),
    onSocialAuth: (provider, token) => dispatch(actions.socialAuth(provider, token)),
    onClearError: () => dispatch(actions.clearError()),
  };
};
const mapStateToProps = state => ({
  loading: state.auth.loading,
  error: state.auth.error,
  isAuthenticated: state.auth.token !== null,
  token: state.auth.token,
  user: state.auth.user,
  language: state.home.selected_language === 1 ? "en" : "ar",
  success_message: state.auth.success_message,
  email: state.profile.userProfile.email,
});
export default connect(mapStateToProps, mapDispatchToProps)(Login);